import React from 'react';
import { Box, Typography } from '@heycater/design-system';
import { Grid, useMediaQuery } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import TopCaterersCard from 'static_pages/marketing_pages/components/TopCaterers/TopCaterersCard';

const SimilarCaterersFactory = ({ similarCaterers, city }) => {
  const mobile = useMediaQuery((theme) => theme.breakpoints.down('xs'));
  const { t } = useTranslation('caterers');

  return (
    <StyledContainer mobile={mobile}>
      <StyledTitle variant="subtitle1">
        {t('caterer.similarCaterersHeader', {
          city: t(`common:cities.${city.toLowerCase()}`),
        })}
      </StyledTitle>
      <Grid container spacing={2}>
        {similarCaterers.map((caterer) => (
          <Grid item md={4} sm={6} xs={12} key={caterer.objectID}>
            <TopCaterersCard caterer={caterer} city={city} imageOnly={false} />
          </Grid>
        ))}
      </Grid>
    </StyledContainer>
  );
};

const StyledContainer = styled(Box)`
  padding-top: ${(props) => props.theme.spacing(props.mobile ? 3 : 4)}px;
  padding-bottom: ${(props) => props.theme.spacing(props.mobile ? 3 : 4)}px;
`;

const StyledTitle = styled(Typography)`
  margin-bottom: ${(props) => props.theme.spacing(3)}px;
`;

export default SimilarCaterersFactory;
